package com.solevo.dist.network.firebase.api.transactions.models

import com.solevo.dist.application.models.Transaction
import com.solevo.dist.network.implementation.firebase.utils.time.toKotlinInstant
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
enum class FirebaseTransactionStatus {
    Open, Closed;
}

@Serializable
enum class FirebaseTransactionType {
    Payment, CreditNote, Invoice, Other, Reimbursement;
}

@Serializable
data class FirebaseTransaction(
    val transactionId: String = "",
    val legalEntityId: String? = null,
    val voucherId: String? = "",
    var invoiceNumber: String? = "",
    val customerId: String = "",
    val type: FirebaseTransactionType = FirebaseTransactionType.Payment,
    val date: Timestamp = Timestamp.now(),
    val invoiceDueDate: Timestamp? = null,
    val invoiceId: String? = "",
    val amount: Double = 0.0,
    val originalAmount: Double = 0.0,
    val remainingAmount: Double = 0.0,
    val currency: String = "",
    val status: FirebaseTransactionStatus = FirebaseTransactionStatus.Open
)

fun FirebaseTransaction.toTransaction(): Transaction {
    return Transaction(
        transactionId = transactionId,
        legalEntityId = legalEntityId,
        voucherId = voucherId,
        invoiceNumber = invoiceNumber,
        customerId = customerId,
        type = when (type) {
            FirebaseTransactionType.Payment -> Transaction.Type.Payment
            FirebaseTransactionType.CreditNote -> Transaction.Type.CreditNote
            FirebaseTransactionType.Invoice -> Transaction.Type.Invoice
            FirebaseTransactionType.Other -> Transaction.Type.Other
            FirebaseTransactionType.Reimbursement -> Transaction.Type.Reimbursement
        },
        date = date.toKotlinInstant(),
        invoiceDueDate = invoiceDueDate?.toKotlinInstant(),
        invoiceId = invoiceId,
        amount = amount,
        originalAmount = originalAmount,
        remainingAmount = remainingAmount,
        currency = currency,
        status = when (status) {
            FirebaseTransactionStatus.Open -> Transaction.Status.Open
            FirebaseTransactionStatus.Closed -> Transaction.Status.Closed
        }
    )
}


